import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Fade + rise on scroll into view.
export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-10% 0px -10% 0px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

// Line-by-line masked reveal for cinematic headlines.
export function MaskLines({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.12 }) {
  const reduce = useReducedMotion();
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: stagger, delayChildren: delay } },
  };
  const child = {
    hidden: reduce ? { opacity: 0 } : { y: "110%", opacity: 0 },
    show: { y: "0%", opacity: 1, transition: { duration: 1, ease: EASE } },
  };
  return (
    <motion.span
      className={className}
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
    >
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask">
          <motion.span variants={child} className={`block ${lineClassName}`}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
}

// On-load masked reveal (for the hero, fires immediately).
export function MaskLinesLoad({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.14 }) {
  const reduce = useReducedMotion();
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            className={`block ${lineClassName}`}
            initial={reduce ? { opacity: 0 } : { y: "115%", opacity: 0 }}
            animate={{ y: "0%", opacity: 1 }}
            transition={{ duration: 1.1, delay: delay + i * stagger, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export { EASE };
